import { title } from 'process'
import React, { FC } from 'react'
import s from './FreeText.module.css'

interface FreeTextProps {
  title?: string
  text?: string

}
const FreeText: FC<FreeTextProps> = ({ title, text }) => {

  return (
    <div className={s.root}>
      <div className={s.cover}>
        <h2 className={`text-title-2 text-tertiary500`}>{title}</h2>
        <p className={`text-paragraph03 text-tertiary500 mt-3`}>{text}</p>
      </div>
    </div>
  )
}

export default FreeText
